import {
  errorHandler,
  requestHandler,
  successHandler,
} from './NetworkInterceptor';
import { axiosInstance, authAxiosInstance } from '../baseUrl';

axiosInstance.interceptors.request.use((request) => requestHandler(request));
axiosInstance.interceptors.response.use(
  (response) => successHandler(response),
  (error) => errorHandler(error),
);

const viomeApiInstance = axiosInstance;
const viomeAuthApiInstance = authAxiosInstance;

export { viomeApiInstance, viomeAuthApiInstance };
